// extracted by mini-css-extract-plugin
export var background = "process-module--background--2M01I";
export var bigger = "process-module--bigger--lu4nb";
export var card = "process-module--card--EKI4Q";
export var cards = "process-module--cards--40ulR";
export var curvedCarousel = "process-module--curvedCarousel--VwQmj";
export var h2 = "process-module--h2--zxuJ5";
export var label = "process-module--label--SyOYx";
export var sectionProcess = "process-module--sectionProcess--NZBz9";